import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import React, { useCallback, useEffect, useMemo, useState } from "react"
import TableContainer from "../../Components/Common/TableContainerReactTable";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { getProducts, addNewProduct, updateProduct, deleteProduct } from "../../slices/products/thunk";
import { Link } from "react-router-dom";
import ModalCreate from "./components/modalCreate";

const Spinner = ({ isLoading }: { isLoading: boolean }) => (
  isLoading ? (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : null
)

const formDefaultStructure: Object[] = [
  {
    "key": "code",
    "title": "Código",
    "placeHolder": "Ingrese el código del producto",
    "type": "text",
    "validators": {
      "required": true,
    },
    'column': 6
  },
  {
    "key": "name",
    "title": "Nombre",
    "placeHolder": "Ingrese el nombre del producto",
    "type": "text",
    "validators": {
      "required": true,
    },
    'column': 6
  },
  {
    "key": "price",
    "title": "Precio",
    "placeHolder": "Ingrese el precio del producto",
    "type": "number",
    "validators": {
      "required": true,
    },
    'column': 6
  },
];

const Products = () => {
  document.title = "Productos";
  const dispatch: any = useDispatch();
  const [openModalCreate, setOpenModalCreate] = useState<boolean>(false)
  const [isUpdate, setIsUpdate] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [currentProduct, setCurrentProduct] = useState<any>(null)

  const { products } = useSelector((state: any) => ({
    products: state.Products.products || [],
  }));

  useEffect(() => {
    dispatch(getProducts())
  }, [dispatch])

  const onSubmit = async (values: any) => {
    setIsLoading(true)
    if (isUpdate && currentProduct) {
      await dispatch(updateProduct({ ...values, id: currentProduct.id }));
    } else {
      await dispatch(addNewProduct(values));
    }
    await dispatch(getProducts());
    setOpenModalCreate(false)
    setIsLoading(false)
  }

  const handleDeleteProduct = useCallback(async (id: string) => {
    setIsLoading(true)
    await dispatch(deleteProduct(id))
    await dispatch(getProducts())
    setIsLoading(false)
  }, [dispatch]);

  const cols = useMemo(
    () => [
      {
        header: "Código",
        accessorKey: "code",
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Precio",
        accessorKey: "price",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return `$${cell.getValue()}`;
        }
      },
      {
        header: "Acciónes",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return <React.Fragment>
            <div className="d-flex flex-row-reverse">
              <div className="flex-grow-1 tasks_name"></div>
              <div className="flex-shrink-0 ms-4">
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <Link to="#" onClick={() => {
                      const productData = cell.row.original;
                      setCurrentProduct(productData);
                      setOpenModalCreate(true);
                      setIsUpdate(true);
                    }}>
                    <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                  <Link to="#" className="remove-item-btn" onClick={() => {
                      const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este producto?")
                      if (confirmDelete) {
                        handleDeleteProduct(cell.row.original.id)
                      }
                    }}>
                    <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                  </Link>
                  </li>
                </ul>
              </div>
            </div>
            </React.Fragment>;
        },
      },
    ],
    [handleDeleteProduct]
  );

  return (<React.Fragment>
      <Spinner isLoading={isLoading}/>
      <DeleteModal/>
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader><h5>PRODUCTOS</h5></CardHeader>
              <CardBody>
                <div className="d-flex flex-column flex-sm-row align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1 fw-bold mt-4 text-center mb-4 col-sm-8">PRODUCTOS</h5>
                  <div className="col-sm-4">
                    <div className="d-flex flex-wrap gap-2">
                      <button className="btn btn-primary add-btn me-1" onClick={() => {
                          setCurrentProduct(null);
                          setIsUpdate(false)
                          setOpenModalCreate(true)
                        }}
                              disabled={isLoading}><i
                        className="ri-add-line align-bottom me-1"></i> Agregar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">

                  <TableContainer
                      columns={cols}
                      data={products || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      theadClass="text-muted text-uppercase"
                      SearchPlaceholder="Buscar por código, nombre..."
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
        <ModalCreate
            show={openModalCreate}
            setOpenModal={setOpenModalCreate}
            onSubmit={onSubmit}
            isUpdate={isUpdate}
            productData={currentProduct}
            formStructure={formDefaultStructure}
        />
      </React.Fragment>
  );
}
export default Products;
